const getServerProps = () => {
  let channex_server;
  let base_url;
  let pathPrefix;
  let publicUrl;
  if (process.env.REACT_APP_SERVER_MODE == "dev") {
    channex_server = process.env.REACT_APP_CHANNEX_DEV_SERVER;
    base_url = process.env.REACT_APP_DEV_BASE_URL;
    // For local development, use /hotelx as the path prefix
    pathPrefix = "/hotelx";
    // For local development, use the local public folder
    publicUrl = process.env.PUBLIC_URL || "";
  } else {
    channex_server = process.env.REACT_APP_CHANNEX_APP_SERVER;
    base_url = process.env.REACT_APP_BASE_URL;
    pathPrefix = "/hotelx";
    publicUrl = "https://apps.revivotech.in/hotelx";
  }
  return { channex_server, base_url, pathPrefix, publicUrl};
};

export { getServerProps };